var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/inherits");

var Gateway = require('./Gateway');

var Web3 = require('web3');

var HTTPGateway =
/*#__PURE__*/
function (_Gateway) {
  "use strict";

  _inherits(HTTPGateway, _Gateway);

  function HTTPGateway(rpcUrl, networkId) {
    var _this;

    _classCallCheck(this, HTTPGateway);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTTPGateway).call(this));
    _this.rpcUrl = rpcUrl;
    _this.networkId = networkId;
    _this._w3Provider = null;
    return _this;
  }

  _createClass(HTTPGateway, [{
    key: "isAvailable",
    value: function isAvailable() {
      return true;
    }
  }, {
    key: "getNetworks",
    value: function getNetworks() {
      return [this.networkId];
    }
  }, {
    key: "_provider",
    value: function _provider() {
      if (!this._w3Provider) {
        this._w3Provider = new Web3.providers.HttpProvider(this.rpcUrl);
      }

      return this._w3Provider;
    }
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(network, _ref) {
        var method, params, id, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = _ref.method, params = _ref.params, id = _ref.id;

                if (!(network !== this.networkId)) {
                  _context.next = 3;
                  break;
                }

                throw new Error('HTTPGateway does not support this network');

              case 3:
                _context.next = 5;
                return this._provider().send(method, params);

              case 5:
                response = _context.sent;
                return _context.abrupt("return", response);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send(_x, _x2) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }]);

  return HTTPGateway;
}(Gateway);

module.exports = HTTPGateway;